module.exports = __webpack_public_path__ + "img/donante-icbc.1a365c52.png";